(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mojoco-landing"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.mj-section').forEach(function (section) {
      var variantsEl = section.querySelector('[data-mj-variants]');
      if (!variantsEl) return;
      var variants = JSON.parse(variantsEl.textContent);

      var form = section.querySelector('#mj-form') || section.querySelector('form');
      var variantIdInput = section.querySelector('[data-mj-variant-id]');
      var quantityInput = section.querySelector('[data-mj-quantity]');
      var selectedValueEl = section.querySelector('[data-mj-selected-value]');
      var tierButtons = section.querySelectorAll('[data-mj-tier]');
      var selectedTierQty = 1;

      var selectedOptionValue = null;
      var activeSwatch = section.querySelector('.mj-swatch.is-active');
      if (activeSwatch) selectedOptionValue = activeSwatch.dataset.mjOptionValue;

      function findVariant() {
        if (!selectedOptionValue) return variants[0];
        return variants.find(function (v) {
          return v.option1 === selectedOptionValue || v.option2 === selectedOptionValue || v.option3 === selectedOptionValue;
        }) || variants[0];
      }

      function formatMoney(cents) {
        return (cents / 100).toLocaleString('cs-CZ', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' Kč';
      }

      function renderTiers() {
        var variant = findVariant();
        if (!variant) return;
        if (variantIdInput) variantIdInput.value = variant.id;

        tierButtons.forEach(function (btn) {
          var qty = parseInt(btn.dataset.qty, 10);
          var pct = parseInt(btn.dataset.pct, 10);
          var originalTotal = variant.price * qty;
          var discountedTotal = Math.round(originalTotal * (1 - pct / 100));

          var compareEl = btn.querySelector('[data-mj-tier-compare]');
          var totalEl = btn.querySelector('[data-mj-tier-total]');

          if (pct > 0) {
            if (compareEl) compareEl.textContent = formatMoney(originalTotal);
            if (totalEl) totalEl.textContent = formatMoney(discountedTotal);
          } else {
            if (totalEl) totalEl.textContent = formatMoney(originalTotal);
          }

          btn.classList.toggle('is-selected', qty === selectedTierQty);
        });
      }

      section.querySelectorAll('.mj-swatch').forEach(function (btn) {
        btn.addEventListener('click', function () {
          section.querySelectorAll('.mj-swatch').forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          selectedOptionValue = btn.dataset.mjOptionValue;
          if (selectedValueEl) selectedValueEl.textContent = selectedOptionValue;
          renderTiers();
        });
      });

      section.querySelectorAll('[data-mj-thumb]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          section.querySelectorAll('[data-mj-thumb]').forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          var main = section.querySelector('[data-mj-main-image]');
          if (main) main.src = btn.dataset.full;
        });
      });

      tierButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          selectedTierQty = parseInt(btn.dataset.qty, 10);
          if (quantityInput) quantityInput.value = selectedTierQty;
          renderTiers();
        });
      });

      renderTiers();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
